import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import PageHeader from 'components/UI/PageHeader/PageHeader';
import React, { createContext, useContext, useState } from 'react';
import { StoreContext } from 'utilities/StoreContextWrapper';
import './Schools.module.scss';
import { useMediaQ } from 'utilities/useMediaQ';
import SearchBar from 'components/UI/SearchBar';
import Card from './components/Card/Card';
import Maps from './components/Maps/Maps';
import CheckBoxes from './components/CheckBoxes/CheckBoxes';

export const SchoolsContext = createContext(null);

export default function Schools() {
    const [selected, setSelected] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const query = useMediaQ('min', 1100);

    const checkboxesLabels = ['vo', 'mbo', 'pabo'];
    const [checkedLabels, setCheckedLabels] = useState([]);

    const { schools } = useContext(StoreContext);

    const schoolsWithIndex = schools.map((school, i) => ({
        ...school,
        index: i + 1,
    }));

    const filteredSchools = schoolsWithIndex.filter((school) => {
        const matchesSearch = searchValue
            ? school?.name.toLowerCase().includes(searchValue.toLowerCase()) ||
              school?.contact?.city
                  .toLowerCase()
                  .includes(searchValue.toLowerCase())
            : true;

        const matchesCheckboxes = checkedLabels.length
            ? checkedLabels.some((label) => school.type?.includes(label))
            : true;

        return matchesSearch && matchesCheckboxes;
    });

    return (
        <SchoolsContext.Provider
            value={{
                selected,
                setSelected,
                checkboxesLabels,
                checkedLabels,
                setCheckedLabels,
            }}
        >
            <Layout>
                <PageHeader />
                <Container background>
                    <div styleName="page-wrapper">
                        <div styleName="schools">
                            <div styleName="top-text ">
                                <h2>Waar kun je ons vinden?</h2>
                                {/* <p>
                                    In de regio van Land van Cuijk, Maasduinen,
                                    Meierijstad en Oss zijn een aantal scholen
                                    uit het vo, mbo en de lerarenopleidingen de
                                    samenwerking aangegaan. Hieronder zie je om
                                    welke scholen het gaat.
                                </p> */}
                            </div>
                            <div styleName="grid">
                                <div styleName="sticky-wrapper">
                                    <div styleName="sticky">
                                        <SearchBar
                                            blueGray
                                            searchValue={searchValue}
                                            setSearchValue={setSearchValue}
                                        />
                                        <CheckBoxes />
                                        <Maps schools={filteredSchools} />
                                    </div>
                                </div>
                                {query ? (
                                    <div styleName="schools-2-columns">
                                        {filteredSchools.map((school) => (
                                            <Card
                                                school={school}
                                                key={school?.index}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <div styleName="schools">
                                        {filteredSchools.map((school) => (
                                            <Card
                                                school={school}
                                                key={school?.index}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Container>
            </Layout>
        </SchoolsContext.Provider>
    );
}
